<template>
  <div ref="editor" :style="editorStyle"></div>
</template>

<script>
import E from 'wangeditor'
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false
    },
    editorStyle: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal.replace(/<\/?[^>]+(>|$)/g, "") != oldVal.replace(/<\/?[^>]+(>|$)/g, "") && this.editor) {
        this.editor.txt.html(newVal)
      }
    },
    disabled(newVal, oldVal) {
      if (this.editor) {
        newVal ? this.editor.disable() : this.editor.enable()
      }
    }
  },
  data() {
    return {
      editor: null,
    }
  },
  mounted() {
    if (!this.editor) {
      this.$nextTick(() => {
        const editor = new E(this.$refs.editor)
        editor.config.onchange = (newHtml) => {
          this.$emit('input', newHtml)
        }
        editor.config.onchangeTimeout = 1000;
        editor.config.uploadImgShowBase64 = false
        editor.create()
        editor.txt.html(this.value)
        this.disabled && editor.disable()
        this.editor = editor
      })
    }
  },
  beforeDestroy() {
    // 销毁编辑器
    this.editor.destroy()
    this.editor = null
  }
}
</script>

<style>

</style>
